module.exports = __webpack_public_path__ + "img/new-barcode-icon-blue.02098d3c.svg";